import { Injectable, OnInit } from '@angular/core';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { UserData } from '../interfaces/user-data';


@Injectable()
export class LoadingService {

  private loading = new BehaviorSubject<boolean>(false);

  constructor() {}

  public getLoadingState(): Observable<boolean> {
    return this.loading.asObservable();
  }

  /**
   * Gibt Daten des Benutzers zurück
   */
  public setLoadingState = (newState: boolean) => {
    this.loading.next(newState);
  }

}
